import { render, staticRenderFns } from "./search-product-input.vue?vue&type=template&id=72ab3f23&"
import script from "./search-product-input.vue?vue&type=script&lang=js&"
export * from "./search-product-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports